import { render, staticRenderFns } from "./Itinerari.vue?vue&type=template&id=b5fdc828"
import script from "./Itinerari.vue?vue&type=script&lang=js"
export * from "./Itinerari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports